import { useMutation, useQuery } from "@tanstack/react-query";
import SettingsApi from "../routes/settings";
import { authLogger } from "../Utils/logger";

// Get notification settings query
export const useGetNotificationSettings = (enabled = true) => {
  return useQuery({
    queryKey: ["settings", "notifications"],
    queryFn: async () => {
      try {
        authLogger.apiRequest("GET", "/settings/notifications");
        const response = await SettingsApi.getNotificationSettings();
        authLogger.apiResponse("GET", "/settings/notifications", response, 200);

        // Extract the data from response.data.data (following the old pattern)
        return response?.data || response;
      } catch (error) {
        authLogger.apiError(
          "GET",
          "/settings/notifications",
          error,
          error.response?.status,
        );
        throw error;
      }
    },
    enabled,
    retry: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 15 * 60 * 1000, // 15 minutes
  });
};

// Update notification settings mutation
export const useUpdateNotificationSettings = () => {
  return useMutation({
    mutationFn: async (settings) => {
      try {
        authLogger.apiRequest("POST", "/settings/notifications", settings);
        const response = await SettingsApi.updateNotificationSettings(settings);
        authLogger.apiResponse(
          "POST",
          "/settings/notifications",
          response,
          200,
        );
        authLogger.userAction("notification_settings_updated", settings);
        return response;
      } catch (error) {
        authLogger.apiError(
          "POST",
          "/settings/notifications",
          error,
          error.response?.status,
        );
        authLogger.userAction("notification_settings_update_failed", {
          settings,
          error: error.message,
        });
        throw error;
      }
    },
  });
};
